import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

const Create = () => {
  const { checkRequiredFields } = useRequiredFields();
  const navigate = useNavigate();
  const { type } = useParams();
  const [inputs, setInputs] = useState({ type, mushok_6_4_show: true }); // initialized type from useParams
  const [unit, setUnit] = useState([]);
  const [unitSupply, setUnitSupply] = useState([]);
  // const [category, setCategory] = useState([]);
  const [error, setError] = useState({});
  const [departments, setDepartments] = useState([]); // For storing factory data
  const [finishedGoodsDepartments, setfinishedGoodsDepartments] = useState([]);
  const [selectedFactoryOption, setSelectedFactoryOption] = useState(null);
  const [shapes, setShapes] = useState([]);
  const [selectedShapes, setSelectedShapes] = useState([]);
  const [shapesLoading, setShapesLoading] = useState(false);
  const [shapesError, setShapesError] = useState(null);

  const [showAccountsForm, setShowAccountsForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [receipt, setReceipt] = useState(null);
  const [role, setRole] = useState({});
  // Effect for handling finished goods form visibility
  // useEffect(() => {
  //   if (inputs.type === "finished_goods") {
  //     setShowAccountsForm(true);
  //   } else {
  //     setShowAccountsForm(false);
  //   }
  // }, [inputs.type]);
  
  // Effect for initial data loading
  useEffect(() => {
    setLoading(true);
    
    const fetchData = async () => {
      try {
        const unitData = await Http.get("/unitSelect2");
        const res = await Http.get("/staff-type-check");
        setRole(res.data);

        if (res.data === "sample") {
          setInputs((values) => ({
            ...values,
            status: "on_test", // fallback to empty if option is undefined
          }));
        } else {
          setInputs((values) => ({
            ...values,
            status: "active",
          }));
        }

        // const categoryData = await Http.get("/productCatSelect2");
        // const codeData = await Http.get(
        //   "/last-code-increment-by-one/products/code/P"
        // );
        // if (inputs.type === "raw_materials") {
        //   const codeData = await Http.get(
        //     "/last-code-increment-by-one/products/code/RM"
        //   );
        //   setReceipt(codeData.data);
        // } else if (inputs.type === "packing_materials") {
        //   const codeData = await Http.get(
        //     "/last-code-increment-by-one/products/code/PM"
        //   );
        //   setReceipt(codeData.data);
        // } else if (inputs.type === "finished_goods") {
        //   const codeData = await Http.get(
        //     "/last-code-increment-by-one/products/code/FG"
        //   );
        //   setReceipt(codeData.data);
        // } else if (inputs.type === "spare_parts") {
        //   const codeData = await Http.get(
        //     "/last-code-increment-by-one/products/code/SP"
        //   );
        //   setReceipt(codeData.data);
        // }

        // Code generation moved to a separate useEffect

        const departmentRes = await Http.get("/departmentArtSelect2");
        setDepartments(departmentRes.data);
        const selectedDepartments = departmentRes.data.filter(
          (dept) => dept.value === 2 || dept.value === 3
        );
        setfinishedGoodsDepartments(selectedDepartments);

        // Set default factory option
        // const selectedFactory = factoryRes.data.find(
        //   (factory) => factory.id === productRes.data.location_id
        // );
        // if (selectedFactory) {
        //   setSelectedFactoryOption({
        //     label: selectedFactory.name,
        //     value: selectedFactory.id,
        //   });
        // }

        setUnit(unitData.data);
        setUnitSupply(unitData.data);
        // setCategory(categoryData.data);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []); // Run only once on component mount
  
  // Effect to update code based on type change
  useEffect(() => {
    if (!inputs.type) return; // Skip if type is not set
    
    let codeEndpoint = "";

    if (inputs.type === "finished_goods" && role === "sample") {
      codeEndpoint = "/last-code-increment-by-one/products/code/SAM-";
    } else {
    
    switch (inputs.type) {
      case "raw_materials":
        codeEndpoint = "/last-code-increment-by-one/products/code/RM";
        break;
      case "packing_materials":
        codeEndpoint = "/last-code-increment-by-one/products/code/PM";
        break;
      case "finished_goods":
        codeEndpoint = "/last-code-increment-by-one/products/code/FG";
        break;
      case "spare_parts":
        codeEndpoint = "/last-code-increment-by-one/products/code/SP";
        break;
      case "stationery":
        codeEndpoint = "/last-code-increment-by-one/products/code/ST";
        break;
      case "furniture":
        codeEndpoint = "/last-code-increment-by-one/products/code/FN";
        break;
      default:
        codeEndpoint = "/last-code-increment-by-one/products/code/P";
    }
  }
    
    // Only fetch new code when type changes
    const updateCode = async () => {
      try {
        const codeData = await Http.get(codeEndpoint);
        setInputs((prevInputs) => ({
          ...prevInputs,
          code: codeData.data,
        }));
      } catch (error) {
        console.error("Code fetch error:", error);
      }
    };
    
    updateCode();
  }, [inputs.type]);

  useEffect(() => {
    if (inputs.type === "finished_goods") {
      setShapesLoading(true);
      setShapesError(null);
      Http.get("/shape")
        .then((res) => {
          // Map the data for react-select: { value, label }
          const options = (res.data || []).map((s) => ({
            value: s.id ?? s.value ?? s.shape_id ?? s,
            label: s.name ?? s.label ?? s.shape_name ?? String(s),
          }));
          setShapes(options);
        })
        .catch((err) => {
          setShapesError("Could not fetch shapes.");
        })
        .finally(() => setShapesLoading(false));
    }
  }, [inputs.type]);

  const selectHandleChange = (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption.value;
    if (actionMeta.name === "department_art_id") {
      setSelectedFactoryOption({
        label: selectedOption.label,
        value: selectedOption.value,
      });
    }

    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Default Load
  // const fetchData = async () => {
  //   const unitData = await Http.get("/unitSelect2");
  //   const categoryData = await Http.get("/productCatSelect2");
  //   const codeData = await Http.get("/last-code-increment-by-one/products/code/P");

  //   setUnit(unitData.data);
  //   setUnitSupply(unitData.data);
  //   setCategory(categoryData.data);
  //   setInputs((prevInputs) => ({
  //     ...prevInputs,
  //     code: codeData.data,
  //   }));
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  // useEffect(() => {
  //   if (inputs.type === "finished_goods") {
  //     setShowAccountsForm(true);
  //   } else {
  //     setShowAccountsForm(false);
  //   }
  // }, [inputs.type]);

  // Update to include supported_shapes
  const formSubmit = (e) => {
    e.preventDefault();
    const isValid = checkRequiredFields();
    let submitPayload = {...inputs};
    if (inputs.type === "finished_goods") {
      submitPayload.supported_shapes = selectedShapes.map((s) => s.value);
    }
    Http.post("/product", submitPayload)
      .then((res) => {
        navigate("/product", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  console.log(inputs.type, "inputs.type");

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Product</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Create Product Form</h6>
            {/* <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div> */}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Code <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${error?.code ? "is-invalid" : ""}`}
                      name="code"
                      value={inputs.code || ""}
                      onChange={handleChange}
                      data-required
                    />
                    {error?.code && (
                      <div className="invalid-feedback d-block">{error.code[0]}</div>
                    )}
                  </div>
                  <div className="col-lg">
                    <label>
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${error?.name ? "is-invalid" : ""}`}
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      data-required
                    />
                    {error?.name && (
                      <div className="invalid-feedback d-block">{error.name[0]}</div>
                    )}
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Unit <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={unit[0]}
                      name="unit_id"
                      options={unit}
                      onChange={selectHandleChange}
                    />
                    {error?.unit_id && (
                      <div className="invalid-feedback d-block">{error.unit_id[0]}</div>
                    )}
                  </div>
                  <div className="col-lg">
                    <label>
                      Price <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${error?.price ? "is-invalid" : ""}`}
                      name="price"
                      value={inputs.price || ""}
                      onChange={handleChange}
                      data-required
                    />
                    {error?.price && (
                      <div className="invalid-feedback d-block">{error.price[0]}</div>
                    )}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>
                      SKU <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${error?.sku ? "is-invalid" : ""}`}
                      name="sku"
                      value={inputs.sku || ""}
                      onChange={handleChange}
                    />
                    {error?.sku && (
                      <div className="invalid-feedback d-block">{error.sku[0]}</div>
                    )}
                  </div>
                  <div className="col-lg">
                    <label>Pack Size</label>
                    <input
                      type="text"
                      className={`form-control ${error?.pack_size ? "is-invalid" : ""}`}
                      name="pack_size"
                      value={inputs.pack_size || ""}
                      onChange={handleChange}
                    />
                    {error?.pack_size && (
                      <div className="invalid-feedback d-block">{error.pack_size[0]}</div>
                    )}
                  </div>
                  <div className="col-lg">
                    <label>Stock</label>
                    <input
                      type="text"
                      className={`form-control ${error?.stock ? "is-invalid" : ""}`}
                      name="stock"
                      value={inputs.stock || ""}
                      onChange={handleChange}
                    />
                    {error?.stock && (
                      <div className="invalid-feedback d-block">{error.stock[0]}</div>
                    )}
                  </div>
                  <div className="col-lg">
                    <label>
                      Type <i className="fa fa-star required"></i>
                    </label>
                    <select
                      className={`form-control ${error?.type ? "is-invalid" : ""}`}
                      name="type"
                      value={inputs.type}
                      onChange={handleChange}
                      data-required
                    >
                      <option value="">Select Type</option>
                      {role === "lab" && (
                        <option value="raw_materials">Raw Materials</option>
                      )}
                      {role === "depot" && (
                        <>
                          <option value="raw_materials">Raw Materials</option>
                          <option value="spare_parts">Spare Parts</option>
                        </>
                      )}
                      {role === "mechanical" && (
                        <option value="spare_parts">Spare Parts</option>
                      )}
                      {role === "electrical" && (
                        <option value="spare_parts">Spare Parts</option>
                      )}
                      {(role === "planning" || role === "sample") && (
                        <option value="finished_goods">Finished Goods</option>
                      )}

                      {role === "gstore" && (
                        <>
                          {/* <option value="raw_materials">Raw Materials</option> */}
                          {/* <option value="spare_parts">Spare Parts</option> */}
                          <option value="stationery">Stationary</option>
                          <option value="furniture">Furniture</option>
                        </>
                      )}
                      {/* {role === 'planning' && (
                        <>
                          <option value="finished_goods">Finished Goods</option>
                          <option value="raw_materials">Raw Materials</option>
                          <option value="spare_parts">Spare Parts</option>
                          <option value="stationery">Stationary</option>
                        </>
                      )} */}
                    </select>
                  </div>
                </div>
                {inputs.type === "finished_goods" && (
                  <div className="row mt-3">
                    <div className="col-lg">
                      <label>Supported Shapes</label>
                      <Select
                        isMulti
                        className="basic-multi-select"
                        classNamePrefix="select"
                        name="supported_shapes"
                        options={shapes}
                        isLoading={shapesLoading}
                        value={selectedShapes}
                        onChange={setSelectedShapes}
                        placeholder={shapesLoading ? "Loading shapes..." : "Select supported shapes"}
                        isDisabled={shapesLoading || shapesError}
                        noOptionsMessage={() => shapesError || "No shapes found"}
                      />
                      {error?.supported_shapes && (
                        <div className="invalid-feedback d-block">{error.supported_shapes[0]}</div>
                      )}
                    </div>
                  </div>
                )}
                <div className="row mt-3">
                  
                  {/* Conditionally render the Department dropdown */}
                  {inputs.type !== "finished_goods" && (
                    <div className="col-lg">
                      <label htmlFor="">
                        Department <i className="fa fa-star required"></i>
                      </label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={"select Department"}
                        onChange={selectHandleChange}
                        name="department_art_id"
                        options={departments}
                      />
                      {error?.department_art_id && (
                        <div className="invalid-feedback d-block">{error.department_art_id[0]}</div>
                      )}
                    </div>
                  )}
                  {inputs.type === "finished_goods" && (
                    <div className="col-lg">
                      <label htmlFor="">
                        Department <i className="fa fa-star required"></i>
                      </label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={{ label: "Select Department", value: "" }}
                        onChange={selectHandleChange}
                        name="department_art_id"
                        options={finishedGoodsDepartments}
                      />
                      {error?.department_art_id && (
                        <div className="invalid-feedback d-block">{error.department_art_id[0]}</div>
                      )}
                    </div>
                  )}

                  <div className="col-lg mt-5">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        name="department_finished_good"
                        className="form-check-input"
                        checked={inputs.department_finished_good || false}
                        onChange={handleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckChecked"
                      >
                        Department Finished Good
                      </label>
                    </div>
                    {error?.department_finished_good && (
                      <div className="invalid-feedback d-block">{error.department_finished_good[0]}</div>
                    )}
                  </div>
                  <div className="col-lg mt-5">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        name="has_handle"
                        className="form-check-input"
                        checked={inputs.has_handle || false}
                        onChange={handleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckChecked"
                      >
                        Has Handle
                      </label>
                    </div>
                    {error?.has_handle && (
                      <div className="invalid-feedback d-block">{error.has_handle[0]}</div>
                    )}
                  </div>
                  <div className="col-lg">
                    <label>Notes</label>
                    <textarea
                      className={`form-control ${error?.notes ? "is-invalid" : ""}`}
                      name="notes"
                      value={inputs.notes || ""}
                      onChange={handleChange}
                    ></textarea>
                    {error?.notes && (
                      <div className="invalid-feedback d-block">{error.notes[0]}</div>
                    )}
                  </div>
                  {/* <div className="col-lg">
                    <label>Status</label>
                    <select
                      className="form-control"
                      name="status"
                      onChange={handleChange}
                    >
                      <option value="">Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div> */}
                </div>

                {/* {showAccountsForm && ( */}
                {/* <>
                  <div className="row mt-5">
                    <div className="col-md-12 mb-3">
                      <h4 className="text-center">Accounts</h4>
                      <hr />
                    </div>

                    <div className="col-lg-6">
                      <label>STD For Accounts:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="std_price_accounts"
                        value={inputs.std_price_accounts || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6">
                      <label>Vat For Accounts:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="vat_value_accounts"
                        value={inputs.vat_value_accounts || ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-12 mt-5">
                      <h4 className="text-center">চালান</h4>
                      <hr />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-lg">
                      <label>একক মূল্য(টাকায়):</label>
                      <input
                        type="text"
                        className="form-control"
                        name="sdv_inv"
                        value={inputs.sdv_inv || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg">
                      <label>সম্পুরক শুল্কের হার:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="sd_inv"
                        value={inputs.sd_inv || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg">
                      <label>মূল্য সংযোজন করের হার/সুনির্দিষ্ট কর:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="vat_inv"
                        value={inputs.vat_inv || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg">
                    <label>
                      সরবরাহের একক: <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={unitSupply[0]}
                      name="unit_supply"
                      options={unitSupply}
                      onChange={selectHandleChange}
                    />
                  </div>
                    <div className="col-lg">
                    <label>
                      পরিমাণ: <i className="fa fa-star required"></i>
                    </label>
                    <input type="text" className="form-control" name="unit_supply_qty" value={inputs.unit_supply_qty || ""} onChange={handleChange} />
                  </div>
                  </div>
                  <div className="row mt-3">
                    
                  </div>
                </> */}
                {/* )} */}

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Create;
